import React from 'react';
import OwlCarousel from 'react-owl-carousel';  
import { Link } from 'react-router-dom';
export default function BlogHome(){
    return(
        <section id="news" className="grey-bg blog-area blog-nav nav-style-1 pt-120 pb-120 pt-md-60 pb-md-60 pt-xs-60 pb-xs-60">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="blog-section-title text-start">
                            <h2 className="style-text">News</h2>
                            <h6 className="semi-title title-line">Blog & Insights</h6>
                            <h2 className="sect-title">Articles from resource library</h2>
                        </div>
                    </div>
                </div>
                <div className="blog-slide">
                    <OwlCarousel items={4}  
                        className="owl-theme"  
                        loop 
                        dots={false}			  
                        margin={30} >
                        <div className="item">
                            <div className="blogs">
                                <div className="blogs__thumb">
                                    <Link to="/news-details">
                                        <img src="assets/img/blog/blog-1.jpg" alt="Blog Img" />
                                    </Link>
                                </div>
                                <span className="tag">IT Solution</span>
                                <div className="blogs__content">
                                    <p><i className="fal fa-calendar-alt"></i> June 21, 2022</p>
                                    <h5><Link className="blog-title" to="/news-details">Technology support allows
                                            erie non-profit to serve</Link></h5>
                                </div>
                            </div>
                        </div>
                        <div className="item">
                            <div className="blogs">
                                <div className="blogs__thumb">
                                    <Link to="/news-details">
                                        <img src="assets/img/blog/blog-2.jpg" alt="Blog Img" />
                                    </Link>
                                </div>
                                <span className="tag">IT Solution</span>
                                <div className="blogs__content">
                                    <p><i className="fal fa-calendar-alt"></i> June 21, 2022</p>
                                    <h5><Link className="blog-title" to="/news-details">Technology support allows
                                            erie non-profit to serve</Link></h5>
                                </div>
                            </div>
                        </div>
                        <div className="item">
                            <div className="blogs">
                                <div className="blogs__thumb">
                                    <Link to="/news-details">
                                        <img src="assets/img/blog/blog-3.jpg" alt="Blog Img" />
                                    </Link>
                                </div>
                                <span className="tag">IT Solution</span>
                                <div className="blogs__content">
                                    <p><i className="fal fa-calendar-alt"></i> June 21, 2022</p>
                                    <h5><Link className="blog-title" to="/news-details">Technology support allows
                                            erie non-profit to serve</Link></h5>
                                </div>
                            </div>
                        </div>
                        <div className="item">
                            <div className="blogs">
                                <div className="blogs__thumb">
                                    <Link to="/news-details">
                                        <img src="assets/img/blog/blog-4.jpg" alt="Blog Img" />
                                    </Link>
                                </div>
                                <span className="tag">IT Solution</span>
                                <div className="blogs__content">
                                    <p><i className="fal fa-calendar-alt"></i> June 21, 2022</p>
                                    <h5><Link className="blog-title" to="/news-details">Technology support allows
                                            erie non-profit to serve</Link></h5>
                                </div>
                            </div>
                        </div>
                        <div className="item">
                            <div className="blogs">
                                <div className="blogs__thumb">
                                    <Link to="/news-details">
                                        <img src="assets/img/blog/blog-1.jpg" alt="Blog Img" />
                                    </Link>
                                </div>
                                <span className="tag">IT Solution</span>
                                <div className="blogs__content">
                                    <p><i className="fal fa-calendar-alt"></i> June 21, 2022</p>
                                    <h5><Link className="blog-title" to="/news-details">Technology support allows
                                            erie non-profit to serve</Link></h5>
                                </div>
                            </div>
                        </div>
                    </OwlCarousel>
                </div>
            </div>
	    </section>
    )
}